export default __webpack_public_path__ + "static/media/loading.edc5d25d.gif";